import React, {useReducer, useEffect, useRef, useContext } from "react";
import legajoContext from "./legajoContex.js";
import { getAllLegajos, addLegajo, updateLegajo, deleteLegajo, getLegajosFromSoftland } from "../../api/legajo.js";
import legajoReducer from "./legajoReducer.js";

//Types
import { 
    ACTUALIZAR_LIST_LEGAJOS,
  } from "./legajoActions";
import authContext from "../authentication/authContex.js";
import { SocketContext } from "../socket/socket.js";

const LegajoState = props =>{
     
    const initialState = {
        legajosList: null
    };
    const server = useContext(SocketContext);

    const [state, dispatch] = useReducer(legajoReducer, initialState);
    const legajosRef = useRef(state.legajosList)

    const ahContext = useContext(authContext);
    const {usuario, verificarTenant} = ahContext;

    const actualizarLegajosList = async () => {
        try{
            const resp = await getAllLegajos();
            const legajo = resp.data.data;
            legajosRef.current = legajo;
            dispatch({
                type: ACTUALIZAR_LIST_LEGAJOS,
                payload: legajo
            });
            return legajo;
        }catch(err){
            console.log(err)
        }
    };

    const actualizarLegajosFromSoftland = async() =>{
        try {
            const resp = await getLegajosFromSoftland();
            dispatch({
                type: ACTUALIZAR_LIST_LEGAJOS,
                payload: [...resp.data.data]
            });
            return resp
        } catch (error) {
            console.log(error);
            return error;
        }
    }

    const agregarLegajo = async (dato) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addlegajo
            const resp = await addLegajo(dato);
            const legajo = resp.data.data;
            return legajo;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarLegajo = async (dato) => {
        try{
            const resp = await updateLegajo(dato._id, dato);
            const legajo = resp.data.data;
            return legajo;
        }catch(err){
            console.log(err)
        }
    }

    const eliminarLegajo = async (id) => {
        try{
            const resp = await deleteLegajo(id);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null){
            actualizarLegajosList();
        }
    },[usuario])

    useEffect(()=>{
         if(server){
            server.on('legajoNew', ({tenantId}) =>{
                console.log("Recibo el evento del Real Time Server legajoUpdated");
                const verification = verificarTenant(tenantId)
                if(verification){
                    actualizarLegajosList();
                }
            })
            server.on('legajoUpdated', ({tenantId,legajoUpdated}) =>{
                console.log("Recibo el evento del Real Time Server legajoUpdated");
                const verification = verificarTenant(tenantId)
                if(verification){
                    let newLegajos = legajosRef.current.map(l => l._id == legajoUpdated._id ? legajoUpdated : l);
                    legajosRef.current = newLegajos;
                    dispatch({
                        type: ACTUALIZAR_LIST_LEGAJOS,
                        payload: newLegajos
                    });
                }
            })
            return () => {
                server.off('legajoNew');
                server.off('legajoUpdated');
            }
        }
    },[server])

    return(
        <legajoContext.Provider
            value={{
                legajosList: state.legajosList,
                actualizarLegajosList,
                actualizarLegajosFromSoftland,
                agregarLegajo,
                modificarLegajo,
                eliminarLegajo,
            }}
        >
            {props.children}
        </legajoContext.Provider>
    )

}

export default LegajoState;